import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import "./Cta.css"; // Your updated CSS file

// --- Popup Modal Component (No changes needed here) ---
const PopupModal = ({ type, title, message, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return createPortal(
    <div className="gnv-popup-overlay" onClick={onClose}>
      <div className={`gnv-popup-container ${type}`} onClick={(e) => e.stopPropagation()}>
        <div className={`gnv-popup-icon ${type}-icon`}>{type === 'success' ? '✓' : '✕'}</div>
        <h4 className="gnv-popup-title">{title}</h4>
        <p className="gnv-popup-message">{message}</p>
        <button onClick={onClose} className="gnv-popup-close-btn">
          Close
        </button>
      </div>
    </div>,
    document.body
  );
};


// --- Main CTA Banner Component ---
const Cta = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [popup, setPopup] = useState(null);

  const WEBHOOK_URL = 'https://n8n.indraq.info/webhook/ec328e11-2f8a-44c2-b719-d96610f439d7';

  const showPopup = (type, title, message) => {
    setPopup({ type, title, message });
    setTimeout(() => setPopup(null), 5000);
  };

  const handleNewsletter = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      showPopup('error', 'Validation Error', 'Please enter your name.');
      return;
    }
    if (!email.trim() || !email.includes('@')) {
      showPopup('error', 'Validation Error', 'Please enter a valid email address.');
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          timestamp: new Date().toISOString(),
          source: 'newsletter_signup',
        }),
      });

      if (res.ok) {
        showPopup('success', 'Successfully Subscribed!', `Check ${email} for a confirmation.`);
        setName('');
        setEmail('');
      } else {
        showPopup('error', 'Subscription Failed', 'Something went wrong on our end. Please try again.');
      }
    } catch (err) {
      console.error("Network error:", err);
      showPopup('error', 'Network Error', 'Check your connection and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="newsletterBanner-section">
        <div className="newsletterBanner-content">
          <h3 className="newsletterBanner-title">Stay Updated on Study Abroad & Visa Trends</h3>
          <p className="newsletterBanner-description">
            Get the latest updates on visa rules, PR options, scholarships, and real student success stories — delivered weekly to your inbox.
          </p>
        </div>

        {/* --- FORM STRUCTURE UPDATED HERE --- */}
        <form noValidate className="newsletterBanner-form" onSubmit={handleNewsletter}>
          {/* The wrapping div is removed. Inputs are now direct children. */}
          <input
            type="text"
            className="newsletterBanner-input"
            placeholder="Enter Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={isLoading}
            required
          />
          <input
            type="email"
            className="newsletterBanner-input"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            required
          />
          <button type="submit" className="newsletterBanner-button" disabled={isLoading}>
            {isLoading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
      </div>

      {popup && (
        <PopupModal
          type={popup.type}
          title={popup.title}
          message={popup.message}
          onClose={() => setPopup(null)}
        />
      )}
    </>
  );
};

export default Cta;